export default __webpack_public_path__ + "static/media/Akthe_m_789.bb379d3b.png";